import { render, staticRenderFns } from "./UserListFavorites.vue?vue&type=template&id=e887e0ac&scoped=true&xmlns%3Ab-row=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./UserListFavorites.vue?vue&type=script&lang=js&"
export * from "./UserListFavorites.vue?vue&type=script&lang=js&"
import style0 from "./UserListFavorites.vue?vue&type=style&index=0&id=e887e0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e887e0ac",
  null
  
)

export default component.exports